import { img1, img2, img3, img4, img5, img6 } from "../../_components/Imagepath";

export default {
    Data: [
        {
          Id: 1,
          key:1,
          Name: "John Smith",
          img:img1,
          Email: "john@example.com",
          Mobile: "+1 989-438-3131",
          Message: "Lorem ipsum dolor sit consectetur",
          Createdon: "19 Dec 2022, 06:12 PM",
          Action: ""
        },
        {
          Id: 2,
          key:2,
          Name: "Johnny",
          img:img2,
          Email: "johnny@example.com",
          Mobile: "+1 843-443-3282",
          Message: "Ut enim ad minim veniam, quis",
          Createdon: "15 Dec 2022, 04:35 PM",
          Action: ""
        },
        {
          Id: 3,
          key:3,
          Name: "Robert",
          img:img3,
          Email: "robert@example.com",
          Mobile: "+1 917-409-0861",
          Message: "Duis aute irure dolor in reprehenderit",
          Createdon: "04 Dec 2022, 04:35 PM",
          Action: ""
        },
        {
          Id: 4,
          key:4,
          Name: "Sharonda",
          img:img4,
          Email: "sharon@example.com",
          Mobile: "+1 956-623-2880",
          Message: "Excepteur sint occaecat cupidatat",
          Createdon: "12 Dec 2022, 04:35 PM",
          Action: ""
        },
        {
          Id: 5,
          key:5,
          Name: "Randall",
          img:img5,
          Email: "randall@example.com",
          Mobile: "+1 707-439-1732",
          Message: "Sed ut perspiciatis unde omnis iste",
          Createdon: "28 Nov 2022, 03:25 PM",
          Action: ""
        },
        {
          Id: 6,
          key:6,
          Name: "Pricilla",
          img:img6,
          Email: "pricilla@example.com",
          Mobile: "+1 559-741-9672",
          Message: "Nemo enim ipsam voluptatem quia",
          Createdon: "15 Nov 2022, 03:25 PM",
          Action: ""
        }
       ]
}